import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { z } from "zod";
import EquipmentTable from "@/components/operations/equipment/equipment-table";

const equipmentSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  type: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/operations/equipment/")({
  validateSearch: equipmentSearchSchema,
  component: EquipmentPage,
});

function EquipmentPage() {
  const searchParams = Route.useSearch();

  return (
<RouteGuardPermissions
      permissions={[{ module: "equipment", actions: ["read"] }]}>
      
    <div className="flex-1 flex flex-col min-h-0">
      <div className="flex-1 min-h-0">
        <EquipmentTable
          currentPage={searchParams.page}
          basePath="/operations/equipment"
          searchParams={searchParams}
        />
      </div>
    </div>
  
    </RouteGuardPermissions>
  );
}
